:host {
  display: inline-flex;
  align-items: center;
  --md-focus-ring-width: 0;
  --md-focus-ring-color: transparent;

  --_omk-radio-label-element-gap: var(--omk-radio-label-element-gap, var(--omk-dimension-spacing-xxsmall));

  // inner components
  --omk-label-color: var(--_omk-radio-label-color);
  --omk-validation-error-color: var(--_omk-radio-validation-message-color);

  gap: var(--_omk-radio-label-element-gap);
  position: relative;
}

:host([disabled]) {
  pointer-events: none;
}

input[type=radio].hide {
  position: absolute;
  opacity: 0;
  left: 0;
  appearance: none;
  margin-block: 0;
  margin-inline: 0;
  padding-block: 0;
  padding-inline: 0;
  border-width: 0;
}
